import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  dialog: {
    marginLeft: 12,
    marginRight: 12,
    marginBottom: 20,
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  favButton: {
    color: theme.palette.type === "light" ? theme.palette.grey[800] : theme.palette.grey[100],
    marginTop: -5,
  },
  dialogTitle: {
    fontSize: 60,
  },
  dialogContent: {
    width: 450,
  },
  videoContainer: {
    width: "100%",
    height: 300,
  },
  videoLoading: {
    width: 150,
    position: "absolute",
    top: "230px",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  signVideo: {
    display: "block",
    marginLeft: "auto",
    marginRight: "auto",
    maxWidth: "100%",
    maxHeight: "100%",
  },
  definition: {
    marginBottom: 20,
  },
  chips: {
    marginBottom: 20,
  },
  dialogSkeleton: {
    width: 300,
    position: "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
  },
  dialogLoading: {
    margin: 20,
  },
  loadingText: {
    color: theme.palette.grey[300],
  },
  /* Tabs */
  tabsPaper: {
    marginBottom: 20,
  },
  tabs: {
    height: tabHeight,
    minHeight: tabHeight,
  },
  tab: {
    fontSize: 16,
    height: tabHeight,
    minHeight: tabHeight,
  },
}));

/* Aux variables */
const tabHeight = 45;
